import { render, staticRenderFns } from "./Inscripcion2.vue?vue&type=template&id=13f8fd7c&"
import script from "./Inscripcion2.vue?vue&type=script&lang=js&"
export * from "./Inscripcion2.vue?vue&type=script&lang=js&"
import style0 from "./Inscripcion2.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports